/* sts-type-routine.js: a routine for every typed visitor (STS-ROUTINE-MISSING-1014).

   The defect, reported on a call 2026-10-14: a shopper the site calls by
   their type ("Built for DSPW skin") got no My routine widget, "Add to my
   routine" said "We could not find your routine", and See my routine opened
   "No results to show yet". The type and the routine live apart: a guest's
   type (customerSkinType) never expires, every device copy of the routine
   does (slqSavedRegimen and slqSavedResults after 30 days, the handoff with
   the tab), and the old theme's quiz takers carry the type with no copy at
   all. A signed-in customer with a type on the account but no regimen row
   behind it reads no routine either (GET /profile and /my-regimen: 204).

   One rule now: a known type always has a routine.
     guest      this device's routine for the type (slqSavedRegimen, 30 days),
                else a saved result's token (slqResultsHandoff /
                slqSavedResults -> GET {api}/widget/regimen, as the results
                page reads it), else the device copy past its 30 days (still
                this type's, re-dated), else the type's default regimen below.
                What it settles on is written back as slqSavedRegimen, so the
                results page, the home glance, the PDP and the widget all read
                the same routine, and an Add has somewhere to land.
     signed in  the account's routine stays the only source; when it has none,
                build() is the fallback the widget and Add read (nothing is
                written: the device copy is a guest's).
   Never under the staff simulator or a preview (they bring their fixture).

   THE DEFAULT REGIMEN: the STSMD (company 206) default for all 16 types at
   every sensitivity, as production holds it, copied verbatim from
   snippets/sts-state-simulator.liquid (where its provenance is written up;
   bin/tests/sts-type-routine.test.mjs fails if the two copies drift).
   `p` slot -> [title, brand, price, dtcVariantId, handle, image]; `t` type ->
   sensitivity -> "AM slots|PM slots". Prices and stock are re-read live by
   every surface (STS.stepFallback.prices), and a sold-out step shows its
   stand-in, so the snapshot's prices are never what a shopper pays.

   PUBLISHED: STS.typeRoutine = {
     build(type, sens?)  -> {steps, skinType, sensitivity, source:'default'} | null
     device(type, stale?) -> this device's copy for the type | null
     ensure(type)        -> a guest's routine now, written to the device | null
     guest(type)         -> Promise of the same, a saved result's token first
     forVisitor()        -> Promise of the current visitor's routine | null
   } */
(function (w, d) {
  'use strict';
  var STS = (w.STS = w.STS || {});
  if (STS.typeRoutine) return;

  var KEY = 'slqSavedRegimen', MAX_AGE = 2592e6;
  var TYPES = ['DSPT', 'DSNT', 'DSPW', 'DSNW', 'OSPT', 'OSNT', 'OSPW', 'OSNW',
    'ORPT', 'ORNT', 'ORPW', 'ORNW', 'DRPT', 'DRNT', 'DRPW', 'DRNW'];

  var TABLE = {
    p: {
    "C01": ["NoLIO BHA Cleanser", "NoLIO", 27, "44870993707310", "nolio-salicylic-acid-cleanser",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/Nolio-BHA-cleanser-front.png?v=1762198839&width=400"],
    "C02": ["Alastin Gentle Cleanser", "Alastin", 58, "47151691366702", "alastin-gentle-cleanser",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/AlastinGentleCleanserheroimageatskintypesolutions.png?v=1785248068&width=400"],
    "C03": ["PCA Skin Facial Wash Oily/Problem", "PCA Skin", 42, "44870623953198", "pca-skin-facial-wash-oily-problem-7-oz",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/pca-skin-facial-wash-oilyproblem-pca-skin-7-fl-oz-468484.png?v=1776969450&width=400"],
    "C04": ["PCA Skin Facial Wash", "PCA Skin", 42, "44870623756590", "pca-skin-facial-wash-7-oz",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/pca-skin-facial-wash-pca-skin-7-fl-oz-871697.png?v=1776968939&width=400"],
    "C05": ["Derma Made Medi Wash", "Derma Made", 32, "44870925484334", "derma-made-medi-wash",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/Derma_made_medi_wash_main_photo.jpg?v=1762198724&width=400"],
    "E01": ["Derma Made Multi-peptide Eye Cream", "Derma Made", 54, "44870929449262", "derma-made-multi-peptide-eye-cream",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/products/derma-made-multi-peptide-eye-cream-derma-made-05-oz-374560.jpg?v=1762198729&width=400"],
    "E02": ["PCA Skin Vitamin B3 Eye Brightening Cream", "PCA Skin", 90, "47325287153966", "pca-skin-vitamin-b3-eye-brightening-cream",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/pca-skin-vitamin-b3-eye-brightening-cream-PCA-Skin-0.46-oz.-shop-at-skin-type-solutions.png?v=1776975987&width=400"],
    "E04": ["Plated Skin Science Eye Serum", "Plated Skin Science", 138, "49166874378542", "plated-skin-science-eye-serum",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/plated-eye-serum-at-skin-type-solutions.png?v=1774302403&width=400"],
    "E05": ["Alastin Restorative Eye Treatment", "Alastin", 118, "44870916473134", "alastin-restorative-eye-treatment",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/Alastin_restorative_eye_new_packaging.png?v=1766083056&width=400"],
    "HA01": ["La Roche-Posay Toleriane Purifying Foaming Cleanser", "La Roche-Posay", 14.99, "47699617481006", "la-roche-posay-toleriane-purifying-foaming-cream",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/la-roche-posay-toleraine-purifying-foaming-cleanser-la-roche-posay-135-fl-oz-shop-at-skin-type-solutions.png?v=1785370094&width=400"],
    "HA02": ["La Roche-Posay Toleriane Hydrating Gentle Cleanser", "La Roche-Posay", 15.99, "44870588694830", "la-roche-posay-toleriane-purifying-foaming-cleanser",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/LaRoche-PosayFacialCleanserLaRoche-PosayTolerianeHydratingGentleCleanser-SkinTypeSolutions-6.76oz.png?v=1785363400&width=400"],
    "HA03": ["PCA Skin Collagen Hydrator", "PCA Skin", 63, "44870622118190", "pca-skin-collagen-hydrator",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/pca-skin-collagen-hydrator-pca-skin-17-fl-oz-144111.png?v=1776968682&width=400"],
    "HA04": ["EltaMD UV Clear Broad-Spectrum SPF 46 Sunscreen", "EltaMD", 76, "51635258622254", "eltamd-uv-clear-broad-spectrum-spf-46",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/EltaMDUVClearBroadSpectrumSPF46.jpg?v=1762198238&width=400"],
    "HA05": ["La Roche-Posay Toleriane Dermallergo Ultra Eyes", "La Roche-Posay", 29.99, "44870588956974", "la-roche-posay-toleriane-ultra-eyes",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/la-roche-posay-toleriane-dermallergo-ultra-eyes-la-roche-posay-067-fl-oz-485591.png?v=1785364230&width=400"],
    "M01": ["PCA Skin Clearskin", "PCA Skin", 63, "44870621987118", "pca-skin-clearskin",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/pca-skin-clearskin-pca-skin-17-fl-oz-120954.png?v=1776968430&width=400"],
    "M02": ["Plated SkinScience INTENSE Serum", "Plated Skin Science", 258, "44870633554222", "plated-skin-science-intensive-repair-serum",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/plated-intense-serum-at-skin-type-solutions_5d15bf46-a1fa-436c-86e4-c1e38df0ab86.png?v=1774301954&width=400"],
    "M03": ["Zerafite Barrier Repair Moisturizer", "Zerafite", 50, "44870991479086", "zerafite-barrier-repair-moisturizer",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/zerafite-barrier-repair-moisturizer-at-skin-type-solutions-front_6382e18f-9f75-4727-ad61-febf6837b788.png?v=1762198836&width=400"],
    "M04": ["PCA Skin ReBalance", "PCA Skin", 63, "44870629032238", "pca-skin-rebalance",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/pca-skin-rebalance-pca-skin-17-fl-oz-892665.png?v=1776968536&width=400"],
    "M05": ["Obagi Professional-C Serum 15%", "Obagi", 130, "44870612779310", "obagi-professional-c-serum-15",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/obagi-professional-c-serum-15-obagi-1-fl-oz-408344.png?v=1781230676&width=400"],
    "M14": ["Zerafite Wrinkle Defense Barrier Cream", "Zerafite", 70, "47696206299438", "zerafite-wrinkle-defense-barrier-cream",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/Zerafite_wrinkle_defense_barrier_cream_new_packaging_HERO_1.png?v=1775672478&width=400"],
    "M35": ["Plated SkinScience INTENSE Serum", "Plated Skin Science", 258, "44870633554222", "plated-skin-science-intensive-repair-serum",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/plated-intense-serum-at-skin-type-solutions_5d15bf46-a1fa-436c-86e4-c1e38df0ab86.png?v=1774301954&width=400"],
    "S02": ["EltaMD UV Active Broad Spectrum SPF 50+", "EltaMD", 45, "44870565953838", "eltamd-uv-active-broad-spectrum-spf-50",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/EltaMDUVActiveBroadSpectrumSPF50.png?v=1773700134&width=400"],
    "S03T": ["Revision Skincare Intellishade Matte SPF 45", "Revision Skincare", 89, "44870648299822", "revision-intellishade-matte-spf-45",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/products/revision-skincare-intellishade-matte-spf-45-revision-17-fl-oz-314575.jpg?v=1762198633&width=400"],
    "S04": ["EltaMD UV Pure Broad-Spectrum SPF 47", "EltaMD", 43, "44870569361710", "eltamd-uv-pure-broad-spectrum-spf-47",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/EltaMD-UV-Pure-Broad-Spectrum-SPF-47-02582A_1.png?v=1773692876&width=400"],
    "T01": ["Plated SkinScience INTENSE Serum", "Plated Skin Science", 258, "44870633554222", "plated-skin-science-intensive-repair-serum",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/plated-intense-serum-at-skin-type-solutions_5d15bf46-a1fa-436c-86e4-c1e38df0ab86.png?v=1774301954&width=400"],
    "T02": ["PCA Skin Vitamin B3 Brightening Serum", "PCA Skin", 130, "44870621200686", "pca-skin-b3-brightening-serum",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/pca-skin-vitamin-b3-brightening-serum-pca-skin-1-fl-oz-235169.png?v=1776969030&width=400"],
    "T03": ["PCA Skin Vitamin B3 Brightening Serum", "PCA Skin", 130, "44870621200686", "pca-skin-b3-brightening-serum",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/pca-skin-vitamin-b3-brightening-serum-pca-skin-1-fl-oz-235169.png?v=1776969030&width=400"],
    "T04": ["Plated SkinScience DAILY Serum", "Plated Skin Science", 258, "45924060234030", "plated-skinscience-revitalizing-essence",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/plated-daily-serum-at-skin-type-solutions.png?v=1774302713&width=400"],
    "T10": ["PAORR By Zerafite Organic Moroccan Argan Oil", "Zerafite", 32.5, "44870990627118", "paorr-organic-moroccan-argan-oil",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/products/paorr-organic-moroccan-argan-oil-paorr-default-title-852339.jpg?v=1762198835&width=400"],
    "T11": ["SkinMedica Retinol Complex 0.25", "SkinMedica", 64, "47211587830062", "skinmedica-retinol-complex-25",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/skinmedicaRetinolComplex0.25.png?v=1771943095&width=400"],
    "T12": ["Derma Made Azelaic Acid Cream 15%", "Derma Made", 42, "49259113054510", "derma-made-azelaic-acid-cream-15",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/derma-made-azelaic-acid-cream-1.7-oz-shop-at-skin-type-solutions.jpg?v=1762200169&width=400"],
    "T13": ["Replenix Gly-Sal 10-2 Clarifying Pads", "Replenix", 36.5, "44870639321390", "replenix-gly-sal-10-2-clarifying-pads",
      "https://cdn.shopify.com/s/files/1/0740/5984/1838/files/replenix-gly-sal-10-2-clarifying-pads-replenix-60-pads-999628.png?v=1778106582&width=400"]
    },
    t: {
    DSPT: {
      S1: "C04,E01,T13,M14,S03T|C02,E01,M14,T11",
      S2: "C05,E01,T12,M14,S03T|C05,E01,T02,M14,T10",
      S3: "C05,E01,T10,M04,S03T|C05,E01,T02,M04,T10",
      S4: "HA02,HA05,HA03,HA04|HA02,HA05,HA03"
    },
    DSNT: {
      S1: "C04,E01,T13,M04,S04|C02,E01,T13,M04,T11",
      S2: "C05,E01,T12,M04,S04|C05,E01,T10,M04",
      S3: "C05,E01,T10,M04,S04|C05,E01,T10,M04",
      S4: "HA02,HA05,HA03,HA04|HA02,HA05,HA03"
    },
    DSPW: {
      S1: "C04,E01,T13,T02,M14,S03T|C02,E01,T13,M04,T11",
      S2: "C05,E01,T02,M14,S03T|C02,E01,T12,M14,T10",
      S3: "C05,E01,T02,M04,S03T|C05,E01,T01,T10,M04",
      S4: "HA02,HA05,HA03,HA04|HA02,HA05,HA03"
    },
    DSNW: {
      S1: "C04,E01,T13,M35,S04|C02,E01,T13,M35,T11",
      S2: "C05,E01,T12,M35,S04|C02,E01,T12,M35,T10",
      S3: "C05,E01,T10,M04,S04|C02,E01,T10,M04,T01",
      S4: "HA02,HA05,HA03,HA04|HA02,HA05,HA03"
    },
    OSPT: {
      S1: "C01,E01,T13,T03,S02|C03,E01,T13,M01,T11",
      S2: "C01,E01,T12,M01,S02|C03,E01,T12,T03,M01",
      S3: "C03,E01,T03,M01,S02|C03,E01,M01,T03",
      S4: "HA01,HA05,HA03,HA04|HA01,HA05,HA03"
    },
    OSNT: {
      S1: "C01,E01,T13,M01,S02|C03,E01,T13,M01,T11",
      S2: "C01,E01,T12,M01,S02|C03,E01,T12,M01",
      S3: "C03,E01,M01,S02|C03,E01,M01",
      S4: "HA01,HA05,HA03,HA04|HA01,HA05,HA03"
    },
    OSPW: {
      S1: "C01,E01,T13,T03,S02|C03,E01,T13,M01,T11",
      S2: "C01,E01,T12,M02,S02|C03,E01,T03,M02",
      S3: "C03,E01,T03,M01,S02|C03,E01,M02,T01",
      S4: "HA01,HA05,HA03,HA04|HA01,HA05,HA03"
    },
    OSNW: {
      S1: "C01,E01,T13,M02,S02|C03,E01,T13,M01,T11",
      S2: "C01,E01,T12,M02,S02|C03,E01,T12,T01",
      S3: "C03,E01,M02,S02|C03,E01,M02,T01",
      S4: "HA01,HA05,HA03,HA04|HA01,HA05,HA03"
    },
    ORPT: {
      R1: "C01,E02,T04,T03,S02|C03,E02,T03,M01,T11"
    },
    ORNT: {
      R1: "C01,M01,S02|C03,M01,T11"
    },
    ORPW: {
      R1: "C01,E02,T04,T03,S02|C03,E02,T03,M02,T11"
    },
    ORNW: {
      R1: "C01,E05,T04,M02,S02|C03,E05,T04,M02,T11"
    },
    DRPT: {
      R1: "C04,E02,T02,M14,S03T|C02,E02,M14,M03,T11"
    },
    DRNT: {
      R1: "C02,E04,T10,M03,S04|C02,E04,T10,M03"
    },
    DRPW: {
      R1: "C04,E02,T02,M14,S03T|C02,E02,M05,M14,T11"
    },
    DRNW: {
      R1: "C04,E05,T04,M35,S04|C02,E05,T04,M35,T11"
    }
    }
  };

  function get(st, k) { try { return w[st].getItem(k); } catch (e) { return null; } }
  function put(k, v) { try { w.localStorage.setItem(k, v); return true; } catch (e) { return false; } }
  function parse(s) { try { return s ? JSON.parse(s) : null; } catch (e) { return null; } }
  function up(v) { return v == null ? '' : String(v).toUpperCase(); }
  function known(t) { t = up(t); return TYPES.indexOf(t) > -1 ? t : ''; }
  function sim() {
    var s = STS.state || {};
    return !!(STS.preview && STS.preview.active) || !!(STS.isSimulated && STS.isSimulated()) ||
      s.source === 'preview' || !!(s.flags && s.flags.preview);
  }

  /* The sensitivity the engine keys the routine on: the quiz's answer on this
     device (customerSensitivityList, a JSON list or a comma string, as
     assets/sts-fit.js reads it), else the one the device copy was built for,
     else the type's first (R1 for a resistant type; S1 as the simulator
     picks for a sensitive one). */
  function sensFor(type, want) {
    var t = TABLE.t[type], k;
    if (!t) return null;
    var list = [];
    if (want) list.push(want);
    var raw = get('localStorage', 'customerSensitivityList'), p = parse(raw);
    if (Array.isArray(p)) list = list.concat(p); else if (raw) list = list.concat(String(raw).split(','));
    var c = parse(get('localStorage', KEY));
    if (c && c.sensitivity) list.push(c.sensitivity);
    for (var i = 0; i < list.length; i++) { k = up(list[i]).trim(); if (t[k]) return k; }
    for (k in t) { if (Object.prototype.hasOwnProperty.call(t, k)) return k; }
    return null;
  }

  /* One step in the shape GET {api}/widget/regimen answers with, the same one
     assets/sts-simulator.js regimenStep builds from this table. */
  function step(slot, time) {
    var p = TABLE.p[slot];
    return {
      slot: slot, time: time, tier: /^[CMS]\d/.test(slot) ? 'starter' : 'complete',
      title: p ? p[0] : null, brand: p ? p[1] : null, image: p ? p[5] : null,
      priceMsrp: p ? p[2] : null, compareAt: null, dtcVariantId: p ? p[3] : null,
      inStock: p ? true : null, handle: p ? p[4] : null, url: p ? '/products/' + p[4] : null,
      keyIngredients: [], ingredientsSummary: null, substituted: false, inOffice: false,
      ledAwayFromBrand: null, swapCandidates: []
    };
  }
  /* AM / PM alternating in slot order with legacy:TIME:n ids, as the wire
     sends it (assets/sts-simulator.js numbered). */
  function build(type, want) {
    type = known(type);
    var sens = type ? sensFor(type, up(want)) : null;
    if (!sens) return null;
    var halves = TABLE.t[type][sens].split('|'), am = [], pm = [], steps = [], i;
    (halves[0] ? halves[0].split(',') : []).forEach(function (s, n) { var x = step(s, 'AM'); x.stepId = 'legacy:AM:' + (n + 1); am.push(x); });
    (halves[1] ? halves[1].split(',') : []).forEach(function (s, n) { var x = step(s, 'PM'); x.stepId = 'legacy:PM:' + (n + 1); pm.push(x); });
    for (i = 0; i < Math.max(am.length, pm.length); i++) {
      if (am[i]) steps.push(am[i]);
      if (pm[i]) steps.push(pm[i]);
    }
    return steps.length ? { steps: steps, skinType: type, sensitivity: sens, source: 'default' } : null;
  }

  /* The results page's own test (assets/sts-liquid-quiz-results.js
     readCachedRegimen): steps, inside 30 days, and written for THIS type; a
     copy naming no type cannot vouch for itself. `stale` waives the 30 days
     only: an older copy of the same type is still this shopper's routine. */
  function device(type, stale) {
    type = known(type);
    var c = parse(get('localStorage', KEY));
    if (!type || !c || !Array.isArray(c.steps) || !c.steps.length) return null;
    if (up(c.skinType) !== type) return null;
    if (!stale && !(c.cachedAt && Date.now() - c.cachedAt < MAX_AGE)) return null;
    return c;
  }

  /* <html data-sts-routine="none"> (snippets/sts-head-state.liquid) hid every
     routine promise for this visit; there is one now. */
  function announce() {
    STS.deviceRoutine = true;
    d.documentElement.removeAttribute('data-sts-routine');
  }
  function write(c) {
    c.cachedAt = Date.now();
    if (put(KEY, JSON.stringify(c))) announce();
    return c;
  }

  /* A guest's routine now, without the network: the fresh copy, the stale one
     re-dated, or the default written down. */
  function ensure(type) {
    type = known(type);
    if (!type || sim() || (STS.state || {}).loggedIn) return null;
    var c = device(type);
    if (c) return c;
    c = device(type, true);
    if (c) return write(c);
    c = build(type);
    return c ? write(c) : null;
  }

  /* A saved quiz result's token for this type: the tab's handoff, then the
     saved results inside their 30 days. */
  function tokens(type) {
    var h = parse(get('sessionStorage', 'slqResultsHandoff')), v = parse(get('localStorage', 'slqSavedResults'));
    if (v && !(v.savedAt && Date.now() - v.savedAt < MAX_AGE)) v = null;
    return [h, v].filter(function (s) { return s && s.widgetToken && (!s.skinType || up(s.skinType) === type); });
  }
  function api() {
    var E = STS.env, b = (E && E.get) ? E.get('apiBase', 'https://api.skintype.pro') : 'https://api.skintype.pro';
    return String(b || 'https://api.skintype.pro').replace(/\/+$/, '');
  }
  /* 8s deadline, as every routine read in the theme has. */
  function net(url, opts) {
    var R = w.STSRoutine;
    if (R && R.net) return R.net(url, opts);
    var ctrl = typeof w.AbortController === 'function' ? new w.AbortController() : null, o = Object.assign({}, opts || {});
    if (ctrl) o.signal = ctrl.signal;
    var t = w.setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
    return w.fetch(url, o).then(function (r) { w.clearTimeout(t); return r; }, function (e) { w.clearTimeout(t); throw e; });
  }
  function fetchRoutine(type, list) {
    if (!list.length) return Promise.resolve(null);
    var src = list[0];
    return net(api() + '/widget/regimen', { headers: { Authorization: 'Bearer ' + src.widgetToken } })
      .then(function (r) { return r.ok && r.status !== 204 ? r.json() : null; })
      .then(function (p) {
        if (!p || !Array.isArray(p.steps) || !p.steps.length) return fetchRoutine(type, list.slice(1));
        return write({ steps: p.steps, ingredientInfo: p.ingredientInfo || null, skinType: type,
          sensitivity: p.sensitivityLevel || src.sensitivityLevel || '', source: 'token' });
      }, function () { return fetchRoutine(type, list.slice(1)); });
  }
  var pending = {};
  function guest(type) {
    type = known(type);
    if (!type || sim() || (STS.state || {}).loggedIn) return Promise.resolve(null);
    var c = device(type);
    if (c) return Promise.resolve(c);
    if (!pending[type]) {
      pending[type] = fetchRoutine(type, tokens(type)).then(function (x) { return x || ensure(type); }, function () { return ensure(type); });
    }
    return pending[type];
  }

  /* The current visitor's: a guest's (guest), a signed-in customer's type's
     default (the account's own routine is read by the caller first). */
  function forVisitor() {
    var s = STS.state || {}, t = s.typed ? known(s.type) : '';
    if (!t || sim()) return Promise.resolve(null);
    return s.loggedIn ? Promise.resolve(build(t)) : guest(t);
  }

  STS.typeRoutine = { build: build, device: device, ensure: ensure, guest: guest, forVisitor: forVisitor, table: TABLE };

  /* A typed guest with nothing on this device gets their routine before the
     deferred readers after this script run (the home glance, the widget, Add
     to my routine), unless a saved token can still fetch the real one. */
  (function boot() {
    var s = STS.state || {}, t = s.typed && !s.loggedIn ? known(s.type) : '';
    if (!t || sim() || device(t)) return;
    if (tokens(t).length) guest(t); else ensure(t);
  }());
}(window, document));
